"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var theme_1 = require("../../theme");
exports.useStyles = makeStyles_1.default(function () {
    return core_1.createStyles({
        select: {
            color: theme_1.contrast().secondary,
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
            '& .MuiOutlinedInput-input.MuiInputBase-input': {
                paddingRight: 30,
                paddingLeft: 0,
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
        icon: {
            fill: theme_1.contrast().primary,
        },
        box: {
            paddingLeft: 60,
        },
    });
});
//# sourceMappingURL=LanguageSelectionStyles.js.map